import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// third-party
import { Provider as ReduxProvider } from 'react-redux';

// scroll bar
import 'simplebar/src/simplebar.css';

// apex-chart
import 'assets/third-party/apex-chart.css';
import 'assets/third-party/react-table.css';

// load mock apis
import '_api';

// project import
import App from './App';
import { store } from 'store';
import { ConfigProvider } from 'contexts/ConfigContext';
import reportWebVitals from './reportWebVitals';
// import { StrictMode } from 'react';
import './styles/globals.css';

const container = document.getElementById('root');
const root = createRoot(container);

// const root = ReactDOM.createRoot(document.getElementById('root'));

// ==============================|| MAIN - REACT DOM RENDER  ||============================== //

root.render(
  // <StrictMode>

  <ReduxProvider store={store}>
    <ConfigProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <App />
      </BrowserRouter>
    </ConfigProvider>
  </ReduxProvider>

  // </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// ==============================|| GLOBAL BUTTON CLICK ANALYTICS (YANDEX METRICA) ||============================== //
// Track all MUI Button clicks and send rich params to Metrica, similar to AB userParams in public/index.html.
(() => {
  if (typeof window === 'undefined') return;
  if (window.__BUTTON_ANALYTICS_BOUND__) return;
  window.__BUTTON_ANALYTICS_BOUND__ = true;

  const METRICA_ID = 94496474;

  const toSafeText = (node) => {
    if (!node) return '';
    const text = (node.getAttribute && node.getAttribute('data-analytics-label')) || node.textContent || '';
    return (text || '').trim().slice(0, 300);
  };

  const getHrefTarget = (el) => {
    if (!el) return null;
    if (el.tagName && el.tagName.toLowerCase() === 'a' && el.getAttribute('href')) {
      return el.getAttribute('href');
    }
    const ownHref = el.getAttribute && el.getAttribute('href');
    if (ownHref) return ownHref;
    const nearestAnchor = el.closest && el.closest('a[href]');
    return (nearestAnchor && nearestAnchor.getAttribute('href')) || null;
  };

  const sendToMetrica = (payload) => {
    try {
      if (typeof window.ym === 'function') {
        // Use userParams for layered/custom params (mirrors AB setup in index.html)
        window.ym(METRICA_ID, 'userParams', { button_click: payload });
      }
    } catch {
      // no-op
    }
  };

  const handler = (event) => {
    // Use capture to ensure we catch the event before navigation
    const buttonEl = event.target && event.target.closest && event.target.closest('.MuiButton-root');
    if (!buttonEl) return;

    const payload = {
      // what
      text: toSafeText(buttonEl),
      id: buttonEl.id || null,
      classes: buttonEl.className || null,
      // where
      url: `${window.location.pathname}${window.location.search || ''}`,
      href: getHrefTarget(buttonEl),
      // when
      ts: Date.now()
    };

    sendToMetrica(payload);
  };

  document.addEventListener('click', handler, true);
})();
